import "@gtsanders/Store/Pages/OrderUpload/GTSOrderUploadReducer"
import {  addWidgetsFromContext } from "@insite/client-framework/Configuration"; // Importing nothing to trigger the side effects, which in this case adds custom reducers.
import {  setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { css } from "styled-components";

const store = require.context("./Store", true);
store.keys().forEach(key => store(key));
if (module.hot) {
    module.hot.accept(store.id, () => onHotWidgetReplace(require.context("./Store", true)));
}
// load all widgets. Without this they won't be included in the bundle
 const widgets = IS_PRODUCTION
     ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
     : require.context("./Widgets", true, /\.tsx$/);
 const onHotWidgetReplace = addWidgetsFromContext(widgets);
 if (module.hot) {
     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
 }

 // Load all handlers so they are included in the bundle.
// Recursively get all handler modifications
const handlers = require.context("./Handlers", true);
// Load the handler modifications.
handlers.keys().forEach(key => handlers(key));
if (module.hot) {
    module.hot.accept(handlers.id, () => onHotWidgetReplace(require.context("./Handlers", true)));
}
// const widgets = IS_PRODUCTION
//     ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
//     : require.context("./Widgets", true, /\.tsx$/);
// const onHotWidgetReplace = addWidgetsFromContext(widgets);
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
// }

// const pages = require.context("./Pages", true, /\.tsx$/);  
// const onHotPageReplace = addPagesFromContext(pages);  
// if (module.hot) {  
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));  
// }
// // load all pages. Without this they won't be included in the bundle  
// const pages = require.context("./Pages", true, /\.tsx$/);  
// const onHotPageReplace = addPagesFromContext(pages);  
// if (module.hot) {  
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));  
// }
//  if (!IS_PRODUCTION) {
//      // load all widget extensions. They could be loaded individually instead
//      const widgetExtensions = require.context("./WidgetExtensions", true);
//      widgetExtensions.keys().forEach(key => widgetExtensions(key));
//  }

// add some post styleguide customizations. These can't be overridden by the style guide
// setPreStyleGuideTheme({
//     header: {
//         isFullWidth: true,
//         fullWidthColor: "#ffffff",
        
//     },
//     footer: {
//         isFullWidth: true,
//         fullWidthColor: "#f3f3f3",
//     },
// });

setPreStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1350],
        maxWidths: [540, 720, 740, 990, 1320]
    },
    colors: {
        primary: {
            main: "#2c4fa0",
            contrast: "#ffffff"
        },
        secondary: {
            main: "#2c4fa0",
            contrast: "#ffffff",
        },
        common: {
            background: "#FFFFFF",
            backgroundContrast: "#363636",
            accent: "#F8F9FA",
            accentContrast: "#363636",
            border: "#CCCCCC",
            disabled: "#CCCCCC",
        },
        text: {
            link: "#2c4fa0"
        },
    },
    clickable: {
        defaultProps: {
            css: css`
            &:focus{
                outline-color: transparent;
                outline-style: none;
                outline-width: 0px;
            }
            *{
                &:focus{
                    outline-color: transparent;
                    outline-style: none;
                    outline-width: 0px;
                }
            }
            `,
        },
    },
});